import i18n from "../../../../i18n";
import getMetricSpec, { type MetricLabel } from "../../utils/metrics";

const DATE_FORMAT_OPTIONS: Intl.DateTimeFormatOptions = {
  year: "numeric",
  month: "short",
  day: "numeric",
};
const formatterCache = new Map<string, Intl.DateTimeFormat>();
const getFormatter = (language: string): Intl.DateTimeFormat => {
  let f = formatterCache.get(language);
  if (!f) {
    f = new Intl.DateTimeFormat(language, DATE_FORMAT_OPTIONS);
    formatterCache.set(language, f);
  }
  return f;
};

export const buildDateColumn = (key: string, colTitle: MetricLabel, options: Record<string, unknown> = {}) => {
  const metricSpec = getMetricSpec(key);
  return {
    key,
    grouping: metricSpec.grouping,
    compareKey: null,
    options: {
      metric: {
        id: key,
        format: "date",
        accessor: (d: Record<string, unknown>) => d[key],
        options: {
          className: "d-flex align-items-center",
          cellContainerClasses: "p-3 align-items-center",
        },
        name: colTitle,
      },
      formatter: (v: string | number | Date | null | undefined) => {
        if (!v) return "-";
        return getFormatter(i18n.language).format(new Date(v));
      },
      hideFilter: true,
      ...options,
    },
  };
};
